import React from 'react'
import PostJobStyles from './PostQA.module.css'
import Typography from '@mui/material/Typography';
import { useLocation, useNavigate } from 'react-router';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import { useState } from 'react';

import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'
import { fetchNotifications } from '../../state/GlobalState'
const PostQA = () => {


    const name=useSelector((state)=>state.globalData.name);
    const count=useSelector((state)=>state.globalData.notificationCount);
    const dispatch =  useDispatch()


    const location = useLocation()
    const data = location.state
    // console.log(data)

    const navigate = useNavigate()

    const [careerJobRoleName, setCareerJobRoleName] = useState('')
    const [jobLocation, setJobLocation] = useState('')
    const [jobType, setJobType] = useState('')
    const [careerJobRoleExperience, setCareerJobRoleExperience] = useState('')
    const [vacancy, setVacancy] = useState('')
    const [faqQuestion, setfaqQuestion] = useState('')
    const [faqAnswer, setfaqAnswer] = useState('')
    const [educationalRequirement, setEducationalRequirement] = useState('')

    const handleSubmit = async (event) => {
        event.preventDefault()
        try {
            const jobResponse = await axios.post(
                `${process.env.REACT_APP_STEELADMIN}/faqCategory/addFaq/${data.faqCategoryId }`,
                { faqQuestion, faqAnswer },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )

            dispatch(fetchNotifications())

           dispatch(setNotificationCount({
            count:count+1,
           }))
           
            alert('Q & A Added.')
            // console.log(jobResponse)

               // this is the snipte for the notification

       const dateTime=jobResponse.data.date;

       const [dateString,timeString]=dateTime.split("T");

       const date=new Date(dateString);

       const time=timeString.substr(0,8);


       const localDate=date.toLocaleDateString();

       dispatch(setNotifications({
           notification:{
             name:name,
             details:jobResponse.data.message,
             time:time,
             date:localDate
           }
         }))
         dispatch(setNotificationCount({
          count:count+1,
         }))
         
       //   uptill here 

            // alert('Job Role Added.')
            
            
        } catch (error) {
            // console.error(error)
        }
        // if(setPostSuccess){
           
        //     alert('FaqCategory Added.')
        //      window.location.reload()
        //     getRolesData();
        // }
        // window.location.reload()
        navigate('/faqpage')
    }

    return (
        <div className={PostJobStyles.jobMain}>
            <div className={PostJobStyles.jobContent}>
                <form action="" className={PostJobStyles.jobForm} onSubmit={handleSubmit}>
                    

                    <label className={PostJobStyles.jobFormLabel}>Question</label>
                    <textarea className={PostJobStyles.jobFormDesc} value={faqQuestion} name='faqQuestion' onChange={(event) => setfaqQuestion(event.target.value)}/>
                    <label className={PostJobStyles.jobFormLabel}>Answer</label>
                    <textarea className={PostJobStyles.jobFormDesc} value={faqAnswer} name='faqAnswer' onChange={(event) => setfaqAnswer(event.target.value)}/>

                
                    <Button type='submit' className={PostJobStyles.postButton} variant='contained'>Submit</Button>
                </form>
            </div>
        </div>
    )
}

export default PostQA